import React from 'react'

export default function AdminTicket() {
  return('')
}
